export default {
  source: {
    url: "mapbox://mepa1363.75azlfv5"
  },
  layer: {
    id: "safety-fire-stations",
    source: "pickyourplace_fire",
    minZoom: 5,
    maxZoom: 22,
    color: "#FFD600",
    icon: "fire-station-15",
    text: "name"
  }
};
